import React, { useEffect } from 'react'
import { Switch, withRouter, Route } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import Clients from 'Containers/Clients'
import ClientView from 'Containers/Clients/ClientView'
import ClientAdd from 'Containers/Clients/ClientAdd'
import ClientEdit from 'Containers/Clients/ClientEdit'

import { AdminRoute, CityManagerRoute } from 'Config/Routing/auth'
import { PATHS } from 'Config/Routing/paths'
import { getCountries } from '../../Reducers/Countries/actions'

const ClientRouter = props => {
  const dispatch = useDispatch()
  const countries = useSelector(state => state.countries.countriesList) || []

  useEffect(() => {
    dispatch(getCountries())
  }, [])
  return (
    <Switch>
      <Route path={props.match.url + PATHS.clients.add}>
        <AdminRoute>
          <ClientAdd countries={countries} />
        </AdminRoute>
      </Route>
      <Route path={props.match.url + PATHS.clients.edit}>
        <AdminRoute>
          <ClientEdit countries={countries} />
        </AdminRoute>
      </Route>
      <Route path={props.match.url + PATHS.clients.clientView}>
        <CityManagerRoute>
          <ClientView countries={countries} />
        </CityManagerRoute>
      </Route>
      <Route path={props.match.url}>
        <CityManagerRoute>
          <Clients countries={countries} />
        </CityManagerRoute>
      </Route>
    </Switch>
  )
}

export default withRouter(ClientRouter)
